export { useDepotDetalhes } from './useDepotDetalhes';
export { useDetalhesTab } from './useDetalhesTab';
export { useAcompanhamentosTab } from './useAcompanhamentosTab';
export { usePedidosTab } from './usePedidosTab';
